
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    filterGroup: {
        display: 'inline-block',
        position: 'relative',
        zIndex: 5,
        marginRight: '8px'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/styles.js